import { useQuery } from '@tanstack/react-query'
import { CACHE_TIMES } from '@/data/services/api/cacheConfig'
import { authService } from '@/data/services/auth/authService'

// Every auth-derived query lives under ['auth'] so a token refresh can
// invalidate the whole family and sign-out can drop it in one call.
export const authKeys = {
  all: ['auth'],
  status: () => [...authKeys.all, 'status'],
  profile: (username) => [...authKeys.all, 'profile', username ?? null],
}

/**
 * Cognito session state: { isAuthenticated, user, token }. Never throws;
 * an unconfigured or signed-out Amplify resolves to the unauthenticated shape.
 */
export function useAuthStatus() {
  return useQuery({
    queryKey: authKeys.status(),
    queryFn: () => authService.getAuthStatus(),
    staleTime: CACHE_TIMES.SHORT_LIVED,
    refetchOnWindowFocus: true,
    retry: false,
    enabled: typeof window !== 'undefined',
  })
}
